export const environment = {
  URL_API: 'https://cmshml-integracao.rodobens.com.br/api',
  URL_API_LEADS_DIGITAL: 'https://leadsdigital-staging.rodobens.com.br/api',
  URL_API_CMS_INTEGRACAO: 'https://cmshml-integracao.rodobens.com.br/api',
  production: false,
  site: 'mbbVeiculosComerciais'
};
